/** Represents the header area of the conversation view. */
export const ConversationHeader = (): JSX.Element => {
  return <>conversation header</>;
};
